import React from 'react';
import { useTranslation } from 'react-i18next';
import { DEEP_DIVE_ART } from './art';
import styles from './styles.module.css';

/**
 * The detail rows: alternating text and visual, one per declared deep-dive.
 *
 * This is the section that carries the ADDED imagery. The eleven pre-existing
 * vertical pages keep their hero photos untouched, and anything new arrives
 * here instead — which is the whole reason this block exists separately from
 * the hero rather than replacing it.
 *
 * `scope` selects the translation namespace so the same component serves
 * feature pages (`features.*`) and vertical pages (`businesses.*`). It defaults
 * to 'features' so existing call sites keep working unchanged.
 */
const DeepDive = ({ scope = 'features', featureKey, count, color = '#F36523' }) => {
  const { t } = useTranslation();
  if (!count) return null;

  const rows = Array.from({ length: count }, (_, i) => i + 1);

  return (
    <section className={styles.section}>
      <div className="container">
        <h2 className={styles.title} data-aos="fade-up">
          {t('features.common.deepDiveTitle', 'In detail')}
        </h2>

        <div className={styles.rows}>
          {rows.map((n) => {
            const Art = DEEP_DIVE_ART[(n - 1) % DEEP_DIVE_ART.length];
            return (
              <div
                key={n}
                className={`${styles.row} ${n % 2 === 0 ? styles.rowFlip : ''}`}
                data-aos="fade-up"
                data-aos-delay={40}
              >
                <div className={styles.copy}>
                  <span className={styles.step} style={{ background: `${color}18`, color }}>
                    {String(n).padStart(2, '0')}
                  </span>
                  <h3>{t(`${scope}.${featureKey}.d${n}t`)}</h3>
                  <p>{t(`${scope}.${featureKey}.d${n}b`)}</p>
                </div>
                <div className={styles.artWrap} aria-hidden="true">
                  <Art color={color} />
                </div>
              </div>
            );
          })}
        </div>
      </div>
    </section>
  );
};

export default DeepDive;
